import { acceptHMRUpdate, defineStore, storeToRefs } from 'pinia'
import { computed } from 'vue'

import {
  useNotificationQuery,
  useUnreadNotificationCountQuery,
} from './composables/useNotification'

import { Pagination, getDefaultPagination } from '../common/models/pagination'
import { Notification } from './models/notification'

import { useAuthSiteStore } from '../user/authSiteStore'
import { useNotificationFilterStore } from './notificationFilterStore'

export const useNotificationStore = defineStore('NotificationStore', () => {
  const authSiteStore = useAuthSiteStore()
  const { currentSite } = storeToRefs(authSiteStore)
  const siteId = computed(() => currentSite.value?.id ?? null)

  const filterStore = useNotificationFilterStore()
  const { perPage, page, filter, typeGroup } = storeToRefs(filterStore)

  // A fetching (all queries) state is indicated to users through the filter component.
  // There is no loading (no data queried OR ready yet) state indicator currently.
  const { data, error } = useNotificationQuery(siteId, {
    perPage,
    page,
    filter,
    typeGroup,
  })

  const notifications = computed<Notification[]>(
    () => data.value?.notifications ?? [],
  )
  const pagination = computed<Pagination>(
    () => data.value?.pagination ?? getDefaultPagination(),
  )

  const { unreadTotal } = useUnreadNotificationCountQuery(siteId)

  return {
    notifications,
    pagination,
    unreadTotal,
    error,
  }
})

if (import.meta.hot !== null && import.meta.hot !== undefined) {
  import.meta.hot.accept(acceptHMRUpdate(useNotificationStore, import.meta.hot))
}
